const MIN_SAMPLE_RATE = 0;
const MAX_SAMPLE_RATE = 1;

interface RuntimeEnvConfig {
  APP_ENVIRONMENT: string;
  CDN_BASE_URL: string;
  APP_VERSION: string;
  STATSIG_CLIENT_KEY: string;
  POSTHOG_API_KEY: string;
  POSTHOG_API_HOST: string;
  SENTRY_DSN: string;
  SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE: string;
  DEEP_LINK_SCHEME: string;
  BROWSER_EXTENSION_ID: string;
}

declare global {
  interface Window {
    __ENV__?: Partial<RuntimeEnvConfig>;
  }
}

function getEnv(): Partial<RuntimeEnvConfig> {
  return window.__ENV__ ?? {};
}

export function getAppEnvironment() {
  return getEnv().APP_ENVIRONMENT ?? 'development';
}

export function getCdnBaseUrl() {
  return getEnv().CDN_BASE_URL ?? '';
}

export function getAppVersion() {
  return getEnv().APP_VERSION ?? '1.0.0';
}

export function getStatsigClientKey() {
  // K8s: entrypoint injects into window.__ENV__ at container startup
  const runtimeKey = getEnv().STATSIG_CLIENT_KEY ?? '';

  if (runtimeKey) {
    return runtimeKey;
  }

  // pnpm dev: Vite reads VITE_STATSIG_CLIENT_KEY from .env.local
  return import.meta.env.VITE_STATSIG_CLIENT_KEY ?? '';
}

export function getPosthogApiKey() {
  const runtimeKey = getEnv().POSTHOG_API_KEY ?? '';

  if (runtimeKey) {
    return runtimeKey;
  }

  return import.meta.env.VITE_POSTHOG_API_KEY ?? '';
}

export function getPosthogApiHost() {
  const runtimeHost = getEnv().POSTHOG_API_HOST ?? '';

  if (runtimeHost) {
    return runtimeHost;
  }

  return import.meta.env.VITE_POSTHOG_API_HOST ?? '';
}

export function getSentryDsn() {
  return getEnv().SENTRY_DSN ?? '';
}

export function getSentryReplayOnErrorSampleRate() {
  const rate = Number.parseFloat(
    getEnv().SENTRY_REPLAY_ON_ERROR_SAMPLE_RATE ?? ''
  );

  if (Number.isNaN(rate)) {
    return MIN_SAMPLE_RATE;
  }

  return Math.min(Math.max(rate, MIN_SAMPLE_RATE), MAX_SAMPLE_RATE);
}

export function getBrowserExtensionId() {
  return getEnv().BROWSER_EXTENSION_ID ?? '';
}
